export const serverError = {
  title: 'На сервері відбулася непердбачувана помилка. Вона незабаром буде виправлена',
  reloadPage: 'Оновити сторінку',
  goMain: 'Повернутися на головну',
};
export default serverError;